import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';

export const SKIP_DEDUPE = new HttpContextToken<boolean>(() => false);

@Injectable()
export class InflightDedupeInterceptor implements HttpInterceptor {
  private readonly inFlight = new Map<string, Observable<HttpEvent<unknown>>>();

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method !== 'GET' || req.context.get(SKIP_DEDUPE)) {
      return next.handle(req);
    }

    const key = this.buildKey(req);
    const cached = this.inFlight.get(key);
    if (cached) {
      return cached;
    }

    const shared$ = next.handle(req).pipe(
      shareReplay({ bufferSize: 1, refCount: false }),
      finalize(() => {
        this.inFlight.delete(key);
      })
    );

    this.inFlight.set(key, shared$);
    return shared$;
  }

  private buildKey(req: HttpRequest<unknown>): string {
    const auth = req.headers.get('Authorization') ?? '';
    return `${req.method} ${req.urlWithParams} ${auth}`;
  }
}
